import { __awaiter } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c9f41fa4"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "overlay overlay_z" }, null, -1));
const _hoisted_2 = { class: "content" };
const _hoisted_3 = { class: "main_title" };
const _hoisted_4 = { class: "main_box" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = {
    key: 1,
    class: "list_box"
};
const _hoisted_7 = { class: "api_list" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "list_box" }, [
    /*#__PURE__*/ _createElementVNode("a", {
        target: "_blank",
        href: "https://cryptos.bigboss-financial.com/docs/",
        class: "link"
    }, "API document")
], -1));
const _hoisted_9 = { class: "button_box" };
import { ref } from 'vue';
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
import { useMessage } from '@/const/messages';
import { useApiRole } from '@/logics/api_role';
export default /*#__PURE__*/ _defineComponent({
    emits: ["close"],
    setup(__props, { emit }) {
        const { MYPAGE_API_MANAGEMENT, format } = useMessage();
        const { isLoading, getApiRoles } = useApiRole();
        const apiRoles = ref([]);
        const onClose = () => emit('close');
        const initalize = () => __awaiter(this, void 0, void 0, function* () {
            apiRoles.value = yield getApiRoles();
            console.log(apiRoles.value);
        });
        initalize();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _hoisted_1,
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("label", null, _toDisplayString(_unref(format)(_unref(MYPAGE_API_MANAGEMENT).LINK_ABOUT_API)), 1),
                        _createVNode(MaterialIcon, {
                            name: "close",
                            class: "close_button",
                            onClick: onClose
                        })
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        (_unref(isLoading))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Loading..."))
                            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("ul", _hoisted_7, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(apiRoles.value, (apiRole) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            key: apiRole.code
                                        }, _toDisplayString(_unref(format)(apiRole.labels)), 1));
                                    }), 128))
                                ])
                            ])),
                        _hoisted_8
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", {
                            onClick: onClose,
                            class: "act-btn"
                        }, _toDisplayString(_unref(format)(_unref(MYPAGE_API_MANAGEMENT).BTN_CLOSE)), 1)
                    ])
                ])
            ], 64));
        };
    }
});
